// WDC Global Main App Entry Point
import React from 'react';
import { createRoot } from 'react-dom/client';
import { CommandCenter } from './components/CommandCenter';
import { createHeadAdminUser, validateSession } from './lib/auth';
import { aiWorkerEngine } from './lib/workers';

// Initialize system
const headAdmin = createHeadAdminUser();

// Simulate session validation (in production, this would come from auth provider)
const session = {
  user: {
    id: headAdmin.id,
    email: headAdmin.email,
    name: headAdmin.name,
    role: headAdmin.role,
    createdAt: headAdmin.createdAt.toISOString(),
  }
};

const user = validateSession(session) || headAdmin;

// Initialize workers and profit loops
aiWorkerEngine.createDefaultWorkers();
aiWorkerEngine.createDefaultProfitLoops();

// Render app
const container = document.getElementById('root');
if (container) {
  const root = createRoot(container);
  root.render(
    <React.StrictMode>
      <CommandCenter user={user} />
    </React.StrictMode>
  );
}